/**
 * Check if element is inview
 * @param {BoundsProps} bounds
 * @param {TriggerProps} trigger
 * @param {Number} windowHeight
 * @param {Number} scrollX
 * @param {Number} scrollY
 * @returns
 */
const checkInview = (bounds, trigger, windowHeight, scrollX, scrollY) => {
  if (!bounds) {
    return true;
  }

  const startOffset = /** @type {Map<String, any>} */ (trigger.get("p_start"));
  const endOffset = /** @type {Map<String, any>} */ (trigger.get("p_end"));

  const start = startOffset.get("value") || 0;
  const end = endOffset.get("value") || windowHeight;

  const height = /** @type {Number} */ (bounds.get("height"));

  const offsetTop = /** @type {Number} */ (bounds.get("offset-top"));
  const offsetLeft = /** @type {Number} */ (bounds.get("offset-left"));

  const y = offsetTop - scrollY;
  const x = offsetLeft - scrollX;

  const offsetEnd = windowHeight - end;
  const position = y + height - offsetEnd;
  const viewport = windowHeight + height - start - offsetEnd;

  return position <= viewport && position >= 0;
};

export default checkInview;
